import _styled from "styled-components";
import React from 'react';
import * as styles from "../styles/SimpleModalBody.styles";
export var SimpleModalBody = function SimpleModalBody(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.container
  }, children);
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "SimpleModalBody___StyledDiv",
  componentId: "sc-1l729f6-0"
})(["", ""], function (p) {
  return p.$_css;
});